<template>
  <el-dialog
    v-dialogDrag
    class="mini-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    :title="title"
  >
    <el-form :model="form" ref="form" label-width="150px">
      <el-form-item :label="`${title}原因`" prop="reason">
        <el-input
          placeholder="请输入驳回原因"
          maxlength="50"
          show-word-limit
          type="textarea"
          rows="3"
          v-model="form.reason"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button size="small" type="primary" class="iconfont icon-save" @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'hidden-reject-dialog',
  props: {
    title: {
      default: '隐患驳回',
    },
  },
  components: {},
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      visible: true,
      form: {},
      formLoading: false,
    }
  },
  computed: {},
  methods: {
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$emit('handleOk', this.form.reason)
        }
      })
    },
  },
  created() {},
}
</script>

<style scoped lang="scss"></style>
